import React from 'react';
import './PackSimulatorModule.css';

export default function PackSimulatorModule({ module, currentSetId }) {
  const data = module.data || {};
  const buttonText = String(data.buttonText || '').trim() || 'Open Pack!';
  const packUrl = `https://www.hearthcards.net/packs/setpack.php?setid=${encodeURIComponent(currentSetId)}`;

  return (
    <section className="set-presentation-section set-pack-callout">
      <div className="container set-wide-section">
        <div className="set-pack-copy">
          {data.title && <h2>{data.title}</h2>}
          {data.content && <p>{data.content}</p>}
          <a className="set-pack-button" href={packUrl} target="_blank" rel="noreferrer">{buttonText}</a>
        </div>
      </div>
    </section>
  );
}
